module.exports = __webpack_public_path__ + "static/media/group-icon.8a801774.svg";